import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';

import ExternalLinkIcon from '~components/common/ExternalLinkIcon';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';

export default function PDFRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');
  const {
    pdf_absentee_form: { text: absenteePDF },
    pdf_emergency_ballot_application: { text: emergencyPDF },
    pdf_register_form: { text: registerPDF },
  } = stateData;

  function regPDF() {
    if (registerPDF) {
      return (
        <a
          href={registerPDF}
          target='_blank'
          rel='noopener'
          title={`${stateName} voter registration application`}
        >
          {stateName} voter registration application
          <ExternalLinkIcon />
        </a>
      );
    }
    return '';
  }

  function absPDF() {
    if (absenteePDF) {
      return (
        <a
          href={absenteePDF}
          target='_blank'
          rel='noopener'
          title={`${stateName} absentee ballot application`}
        >
          {stateName} absentee ballot application
          <ExternalLinkIcon />
        </a>
      );
    }
    return '';
  }

  function emergPDF() {
    if (emergencyPDF) {
      return (
        <a
          href={emergencyPDF}
          target='_blank'
          rel='noopener'
          title={`${stateName} emergency ballot application`}
        >
          {stateName} emergency ballot application
          <ExternalLinkIcon />
        </a>
      );
    }
    return '';
  }

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <TableData>{regPDF() ? regPDF() : 'N/A'}</TableData>
      <TableData>{absPDF() ? absPDF() : 'N/A'}</TableData>
      <TableData>{emergPDF() ? emergPDF() : 'N/A'}</TableData>
    </TableRow>
  );
}

PDFRowRenderer.propTypes = rowRendererProps;
